<template>
  <FullPopup
    title="이메일 주소 등록"
    @on-click-back="$emit('on-click-back')"
    @on-click-close="$emit('on-click-close')"
  >
    <template #contents>
      <div class="contents">
        <div class="input-area">
          <label for="register-email"
            ><span
              >자동 결제 알림을 수신한 이메일 주소를 등록해주세요.<br />사용중인
              이메일 주소를 등록해야 쿠폰 사용이 가능합니다.</span
            ></label
          >
          <input
            id="register-email"
            type="text"
            title="프로필 이름 변경 입력 영역"
            :value="emailValue"
            placeholder="이메일 주소를 입력해주세요 (필수)"
            @input="setInput($event)"
          />
        </div>
        <div class="notice-area">
          <ul>
            <li>
              <p>
                <i class="icon-empty"></i>
                <span
                  >로그인, 비밀번호 찾기, 알림에 사용되니 정확한 이메일을
                  입력해주세요.</span
                >
              </p>
            </li>
          </ul>
        </div>
      </div>
      <div class="cta">
        <p class="cta-notice">
          2021년 5월부터 아이디가 이메일 형식으로 변경되었습니다.
        </p>
        <button type="button" class="btn-confirm" @click="onClickSubmit">
          확인
        </button>
      </div>
    </template>
  </FullPopup>
</template>
<script setup>
  import { ref, defineEmits } from 'vue'
  import { checkValidEmail } from '@/common/util/check-valid-email'
  import utils from '@/common/util/utils'
  import { MSG_INVALID_EMAIL } from '@/common/util/coupon/const'
  import FullPopup from '@/components/ui/FullPopup.vue'

  const emailValue = ref('')

  const emit = defineEmits([
    'on-click-submit',
    'on-click-back',
    'on-click-close',
  ])

  const setInput = (e) => {
    emailValue.value = e.target.value
  }

  const onClickSubmit = () => {
    const isValid = checkValidEmail(emailValue.value)
    if (!isValid) {
      utils.alert(MSG_INVALID_EMAIL)
      emailValue.value = ''
      return undefined
    }

    emit('on-click-submit', emailValue.value)
  }
</script>
<style lang="scss" scoped>
  .contents {
    margin-top: 24px;
    padding: 0 12px;
    .input-area {
      max-width: 375px;
      margin: 0 auto;
      label {
        font-size: 14px;
      }
      input {
        margin-top: 20px;
        width: 100%;
        padding: 15px;
        font-size: 14px;
        line-height: 16px;
        color: #a5a5a5;
        border-radius: 5px;
        background-color: #2f2f2f;
        &::placeholder {
          color: #a5a5a5;
        }
        &[type='text']:focus {
          border: none;
        }
      }
    }
    .notice-area {
      margin-top: 8px;
      ul {
        li {
          > p {
            display: flex;
            font-size: 12px;
            line-height: 18px;
            .icon-empty {
              display: block;
              width: 20px;
              height: 20px;
              background: url('../../../../assets/images/img-error02.png')
                no-repeat center / 15px;
            }
            > span {
              display: block;
              margin-left: 4px;
            }
          }
        }
      }
    }
  }
  .cta {
    width: 100%;
    margin-top: auto;
    &-notice {
      position: relative;
      margin-bottom: 4px;
      padding: 0 12px 0 18px;
      font-size: 12px;
      line-height: 18px;
      color: #7e7e7e;
      &:before {
        position: absolute;
        content: '';
        top: 9px;
        width: 2px;
        height: 2px;
        margin-left: -6px;
        background-color: #7e7e7e;
        border-radius: 1px;
      }
    }

    .btn-confirm {
      width: 100%;
      height: 48px;
      background-color: #0050ff;
      margin-top: 20px;
      padding: 12px 0;
      font-size: 16px;
      line-height: 24px;
      color: #fff;
      text-align: center;
    }
  }
</style>
